import React, { useContext } from "react"
import { useSelector } from "react-redux"

import { Button, FeatureBadge, FeatureTooltip, Icon, InlineButton, Text } from "@driftt/dds"
import { faLock } from "@driftt/dds.icons/regular/faLock"

import { ICPSettingsContext } from "context/icpSettingsContext"
import { getCurrentOrg } from "selectors"
import { segmentTrack,TrackType } from "utils/tracking"

const ICPInfoTooltip = ({ isAdmin }: { isAdmin: boolean }) => {
  const {setShowPreferencesModal } = useContext(ICPSettingsContext)
  const org = useSelector(getCurrentOrg)

  const track = () => {
    segmentTrack(
      TrackType.ACCOUNT_FIT_LOCK_CLICK, 
      {
        orgId: org.id,
        isAdmin
      })
  }

  return (
    <FeatureTooltip.Root>
        <FeatureTooltip.Trigger>
          <InlineButton onClick={track}>
            <Icon icon={faLock}/> 
          </InlineButton>
        </FeatureTooltip.Trigger>
        <FeatureTooltip.Content orientation='vertical' side='right'>
          <FeatureBadge variant="new" bolt />
          <FeatureTooltip.ContentHeader>
            {isAdmin 
              ? "Define your ICP to generate an account fit score in Drift"
              : "Ask an admin to define your organization's ICP to see Drift's account fit score"}
          </FeatureTooltip.ContentHeader>
          <Text>
            Drift&apos;s AI-powered account fit score will assign a score to accounts that visit your
            site based on how closely they match your organization&apos;s ideal customer profile.
          </Text>
          { isAdmin &&
            <FeatureTooltip.ContentActions>
              <Button onClick={() => {
                setShowPreferencesModal(true)
              }}>Define ICP</Button>
            </FeatureTooltip.ContentActions>
          }
        </FeatureTooltip.Content>
      </FeatureTooltip.Root>
  )
}

export default ICPInfoTooltip